module.exports = __webpack_public_path__ + "img/trailerDrivingVerify.beb5e904.jpg";